<template>
  <Modal
    @modalClose="handleClose"
    :cover-closeable="false"
    :show-close="false"
    :show-back="false"
    :not-shadow="true"
    :name="modalName"
    class="modal-common"
  >
    <!-- 未开始 -->
    <div class="act notstart" slot="modal-content" v-if="commonType==='notstart'">
      <!-- <div class="error" @click="handleClose"></div> -->
      <div class="title">活动还未开始，敬请期待</div>
      <!-- <div class="actDes">
        <p>活动将于X年X月X日</p>
        <p>18:00开始</p>
      </div> -->
      <!-- <div class="btn" @click="handleKnow"></div> -->
    </div>
    <!-- 已结束 -->
    <div class="act ended" slot="modal-content" v-if="commonType==='ended'">
      <!-- <div class="error" @click="handleClose"></div> -->
      <div class="title">活动已结束，下次早点来哦~</div>
      <!-- <div class="actDes">
        <p>活动已结束</p>
        <p>18:00结束</p>
      </div> -->
      <!-- <div class="btn" @click="handleKnow"></div> -->
    </div>
    <!-- 已下线 -->
    <div class="act offline" slot="modal-content" v-if="commonType==='offline'">
      <!-- <div class="error" @click="handleClose"></div> -->
      <div class="title">活动已下线，下次早点来哦~</div>
      <!-- <div class="actDes">
        <p>您所在的城市不在本次活动范围内</p>
        <p>可查看其他更多精彩活动哦～</p>
      </div> -->
      <!-- <div class="btn" @click="handleKnow"></div> -->
    </div>
  </Modal>
</template>

<script>
import { webviewInfo, native } from '@ali/amap-lib';
import Modal from '../Modal.vue';
import jumpHandler from '../../js/jumpHandler';

export default {
  name: 'modalCommonShow',
  // commonType：notstart ended offline
  props: ['commonType', 'jumpAction'],
  components: {
    Modal
  },
  data() {
    return {
      modalName: 'modalCommonShow'
    };
  },
  methods: {
    // 退出活动
    handleClose() {
      this.$emit('modalHandler', 'modalClose', this.modalName);
    },
    // 知道的点击事件
    handleKnow() {
      setTimeout(() => {
        this.handleClose();
      }, 0);
      if (webviewInfo.isInAmap()) {
        if (this.jumpAction) {
          jumpHandler(this.jumpAction, {
            needSchema: true,
            delay: 0,
            hideTitleBar: true,
          });
        } else {
          native.closeCurrentWebview();
        }
      } else {
        window.history.back();
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../css/common-mixin";
.act {
  width: rpx(562);
  height: rpx(334);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  // justify-content: flex-start;
  justify-content: center;
  align-items: center;
  text-align: center;
  // padding-top: rpx(50);
  border-radius: rpx(20);
  .error{
    width: rpx(26);
    height: rpx(26);
    background: url('../../../assets/index/close-error.png')
      no-repeat center center;
    background-size: cover;
    position: absolute;
    top: rpx(20);
    right: rpx(20);
    z-index: 200;
    text-align: center;
    color: #fff;
  }
  .title{
    // color: #E44A4A;
    color: #000000;
    font-size: rpx(36);
  }
  .actDes{
    width: 90%;
    color:#333333;
    padding: rpx(5) 0;
    font-size: rpx(30);
    height: 1.2rem;
    p{
      width: 100%;
    }
  }
  .btn{
    margin-top:rpx(10);
    width:100%;
    height: rpx(75);
    background: url("../../../assets/index/know-btn.png") no-repeat center;
    background-size:contain;
  }
}
</style>
